import { useState, ReactNode } from 'react';

interface CollapsibleSectionProps {
  title: string;
  icon: string;
  children: ReactNode;
  defaultOpen?: boolean;
  badge?: string | number;
  badgeColor?: string;
  accent?: string;
}

export default function CollapsibleSection({
  title,
  icon,
  children,
  defaultOpen = true,
  badge,
  badgeColor = 'bg-orange-100 text-orange-700',
  accent = 'border-orange-200',
}: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`bg-white rounded-xl border ${accent} overflow-hidden transition-all`}>
      <button
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between px-5 py-4 hover:bg-slate-50 transition-colors cursor-pointer"
      >
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className={`${icon} text-xl text-slate-700`}></i>
          </div>
          <span className="font-semibold text-slate-900 text-base">{title}</span>
          {badge !== undefined && (
            <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${badgeColor}`}>
              {badge}
            </span>
          )}
        </div>
        <i className={open ? 'ri-arrow-up-s-line text-xl text-slate-400' : 'ri-arrow-down-s-line text-xl text-slate-400'}></i>
      </button>
      {open && (
        <div className="px-5 pb-5 pt-1">
          {children}
        </div>
      )}
    </div>
  );
}
